import React, {useState, useEffect, useRef} from 'react';
import { useLocation } from 'react-router-dom';
import Match from '../components/Match';
import './Calendar.css';

import axios from 'axios';
import { apiLink, domain } from '../variables';
import Pagination from '../components/Calendar/Pagination';
import PlayoffEncounter from '../components/Playoffs/PlayOffDownEncounter';
import PlayoffDownEncounter from '../components/Playoffs/PlayOffDownEncounter';
import logoProAM from '../assets/proam.png'
import logoProBM from '../assets/probm.png'
import logoProAD from '../assets/proad.png'
import logoProBD from '../assets/probd.png'

var XMLParser = require('react-xml-parser');

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

function Calendar({championnat}) {
    const matchRef = useRef(null);
    const location = useLocation(); 
    
    const [matchs, setMatchs] = useState(null);
    const [livescoringMatchs, setLivescoringMatchs] = useState([]);

    // Play-offs
    const [playoffMatchs, setPlayoffMatchs] = useState(null);
    const [playdownMatchs, setPlaydownMatchs] = useState(null);

    //
    const [currentDay, setCurrentDay] = useState(0);
    const maxDayResponsive = 4;


    useEffect(() => {
        setCurrentDay(0);
        // on récupère les matchs
        getMatchs();
        getLivescoringMatchs();
        getPlayoffMatchs();
        getPlaydownMatchs();
    }, [championnat]);

    useEffect(() => {
        if (matchs) {
            scrollToMatch()
        }
    }, [matchs]);

    useEffect(() => {
        goToDay();
    }, [playoffMatchs, playdownMatchs])

    const scrollToMatch = () => {
        if (location.state?.goTo) {
            if (matchRef.current) {
                matchRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }
    }

    const goToDay = () => {
        if (location.state?.off_down_matchs_day) {
            const day = parseInt(location.state?.off_down_matchs_day);
            const rencId = parseInt(location.state?.off_down_matchs_id);
            switch (day) {
                case 17:
                case 18:
                    setCurrentDay(12);
                    break;
                case 19:
                case 20:
                    setCurrentDay(13);
                    break;
                case 21:
                case 22:
                    setCurrentDay(14);
                    break;
                default:
                    return;
            }

            if (rencId) {
                if (matchRef.current) {
                    matchRef.current.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    }

    // on récupère les matchs de playoffs
    const getPlayoffMatchs = async () => {
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                day: 0,
                offOrDown: "off",
                withSets: false
            })

            if (response) {
                setPlayoffMatchs(response.data);
            }
        } 
        catch (error) {
            console.log(error);
        }
    }

    // on récupère les matchs de playdowns
    const getPlaydownMatchs = async () => {
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                day: 0,
                offOrDown: "down",
                withSets: false
            })

            if (response) {
                setPlaydownMatchs(response.data);
            }
        } 
        catch (error) {
            console.log(error);
        }
    }

    const getMatchs = async () => {
        const link = apiLink.find(item => item.for == championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                var data = new XMLParser().parseFromString(res.data).children;
                setMatchs(data);
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const getLivescoringMatchs = async () => {
        const link = "https://fftt.dafunker.com/livescore/all_livescores";
        axios
        .get(link, {
            "Content-Type": "application/xml; charset=utf-8"
        })
        .then(function(res) {
            var data = res.data;
            setLivescoringMatchs(data)
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    const getHeaderLivescore = (renc_id) => {
        let headerLivescore = {};
        if (livescoringMatchs !== null && livescoringMatchs !== undefined) {
            if (livescoringMatchs.list !== undefined) {
                for (const div of livescoringMatchs.list) {
                    // S'il y a des matchs dans la div alors on regarde s'il y a le match qu'on veut
                    const match = div.matchs.find(item => item.renc_id === renc_id.toString());
                    if (match !== undefined) {
                        headerLivescore = match;
                        break; // Sort complètement de la boucle externe
                    }
                }
            }
        }
        return headerLivescore;
    }
    const getTotalDayPerChampionnat = () => {
        let total = 0;
        if (matchs !== null) {
            matchs.forEach((match) => {
                let tour = match.getElementsByTagName('libelle')[0].value.toString();
                tour = parseInt(tour.split('°')[1].split(' ')[0]);
                if (tour > total) {
                    total = tour;
                }
            })
        }
        // on veut ajouter les playoffs
        if (championnat === 'probm' || championnat === "proad" || championnat === 'proam') {
            total += 3;
        }
        return total;
    }


    const handleDayClick = (e, value) => {
        if (value == currentDay) { 
            setCurrentDay(0) // if already clicked then we cancel the filter
        }
        else {
            setCurrentDay(value) // otherwise we go to day x
        }
    }


    const getDayMatch = (index) => {
        let tour = matchs[index].getElementsByTagName('libelle')[0].value.toString();
        tour = tour.split('°')[1].split(' ')[0];
        return parseInt(tour);
    }

    const getRencID = (index) => {
        const cData = matchs[index].getElementsByTagName('lien')[0].value;
        const rencID = cData.split('renc_id=')[1].split('&')[0];
        return rencID;
    }

    // Fonction pour la concordance avec les journées SPID
    const renderMatchPlayOffDown = (day, matchDay) => {
        day = parseInt(day);
        matchDay = parseInt(matchDay);

        if (championnat === 'proam') {
            // Demi-Finale
            if ((matchDay === 23 || matchDay === 24) && day === 19) {
                return true;
            }
            // Finale
            return (matchDay === 25 && day === 20);
        } else {
            // matchDay représente la journée SPID
            // day représente le numéro de notre page sur le site / le numéro de la journée
            // Il y a deux matchs par "journée"
            // Quart de finale
            if ((matchDay === 16 || matchDay === 17) && day === 12) {
                return true;
            }
            // Demi-Finale
            if ((matchDay === 18 || matchDay === 19) && day === 13) {
                return true;
            }
            // Finale
            return (matchDay === 20 || matchDay === 21) && day === 14;
        }
    }

    return ( 
        <div className="calendar_page">
            
            {/* // BANNIERE */}
            <div className={"top_banniere " + championnat}>
                {
                    championnat == 'proam' &&
                        <span>
                            <img src={logoProAM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'proad' &&
                        <span>
                            <img src={logoProAD} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probm' &&
                        <span>
                            <img src={logoProBM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probd' &&
                        <span>
                            <img src={logoProBD} alt="Logo pro" className="logo_p" />
                        </span>
                }  
                <span className="top_banniere_title">
                    Calendrier / Résultats
                </span>
            </div>

            <div className="calendar_content">
                <Pagination
                    division={championnat}
                    currentPage={currentDay} 
                    totalPage={getTotalDayPerChampionnat()}
                    handleDayClick={handleDayClick} 
                    visible={true}
                />
                <div className="matchs_container">
                    {
                        matchs !== null &&
                        matchs.map((item, index) => {
                            return (
                                ((currentDay !== 0 && currentDay == getDayMatch(index)) || currentDay == 0)
                                &&
                                <div key={getRencID(index)} id={getRencID(index)} ref={parseInt(getRencID(index)) === parseInt(location.state?.goTo) ? matchRef : null}>
                                    <Match 
                                        championnat={championnat}
                                        match={item} 
                                        deploy={location.state?.goTo}
                                        showTour={currentDay == 0}
                                        headerLivescore={getHeaderLivescore(getRencID(index))}
                                        currentDay={getDayMatch(index)}
                                    />
                                </div>
                               
                            )
                        })
                    }
                    {playoffMatchs?.map((match, index) => {
                        return (
                            (renderMatchPlayOffDown(currentDay, match?.day_id)) && (
                                <div 
                                    key={match?.renc_id} 
                                    id={match?.renc_id}
                                    ref={parseInt(match?.renc_id) === parseInt(location.state?.off_down_matchs_id) ? matchRef : null}
                                >
                                    <PlayoffDownEncounter
                                        division={championnat}
                                        match={match} 
                                        headerLivescore={getHeaderLivescore(match?.renc_id)}
                                        deploy={parseInt(match?.renc_id) === parseInt(location.state?.off_down_matchs_id)}
                                        offOrDown="off"
                                    />
                                </div>
                            )
                        )
                    })}
                    {playdownMatchs?.map((match, index) => {
                        return (
                            (renderMatchPlayOffDown(currentDay, match?.day_id)) && (
                                <div 
                                    key={match?.renc_id} 
                                    id={match?.renc_id}
                                    ref={parseInt(match?.renc_id) === parseInt(location.state?.off_down_matchs_id) ? matchRef : null}
                                >
                                    <PlayoffDownEncounter
                                        division={championnat}
                                        match={match} 
                                        headerLivescore={getHeaderLivescore(match?.renc_id)}
                                        deploy={parseInt(match?.renc_id) === parseInt(location.state?.off_down_matchs_id)}
                                        offOrDown="down"
                                    />
                                </div>
                            )
                        )
                    })}
                </div>
                <Pagination
                    division={championnat}
                    currentPage={currentDay} 
                    totalPage={getTotalDayPerChampionnat()}
                    handleDayClick={handleDayClick} 
                    visible={getWindowSize().innerWidth <= 1000}
                />
            </div>

            


        </div>
    );
}

export default Calendar;